<template>
    <div class="flex flex-row items-center text-xl">
        <font-awesome-icon class="mr-3 h-8 fa-spin" :spin="true" :icon="loader" />
        <span>{{ message }}</span>
    </div>
</template>

<script>
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';

export default {
    props: {
        message: {
            type: String,
            default: 'Loading...',
        },
    },

    computed: {
        loader() {
            return faSpinner;
        },
    },
};
</script>
